export default "__VITE_ASSET__BFx4RA9h__"